<template>
  <Portal to="lightbox">
    <transition name="fade">
      <div class="hmt-lightbox" v-if="show">
        <div class="hmt-lightbox__backdrop"></div>
        <div class="hmt-lightbox__counter">
          {{`${photoIndex + 1} / ${items.length}`}}
        </div>
        <button class="hmt-lightbox__close" @click="close">
          <FontAwesomeIcon icon="times" size="2x" />
        </button>
        <div class="hmt-lightbox__container">
          <div class="hmt-lightbox__backcover" @click="close"></div>
          <HMTImageWrapper /> <!-- Used as preloader -->
          <div class="hmt-lightbox__photo"
            v-dragscroll.x
            v-on:dragscrollmove="onDragMove($event)"
            v-on:dragscrollend="onDragEnd"
            :class="{
              'hmt-lightbox__photo--is-transition': isTransitionClass,
              'hmt-lightbox__photo--is-grabbing': isGrabbingClass
            }"
            :style="{
              transform: `translateX(${distance}px)`,
              opacity: opacity
            }"
          >
            <lazy-image 
              :src="photo"
              :key="photo"
            />
          </div>
          <div class="hmt-lightbox__controls">
            <button class="hmt-lightbox__controls-button hmt-lightbox__controls-button--prev" 
              @click="onPrevious"
            >
              <FontAwesomeIcon icon="chevron-left" size="3x" />
            </button>
            <button class="hmt-lightbox__controls-button hmt-lightbox__controls-button--next"
              @click="onNext"
            >
              <FontAwesomeIcon icon="chevron-right" size="3x" />
            </button>
          </div>
        </div>
      </div>
    </transition>
  </Portal>
</template>

<script>
  import { dragscroll } from 'vue-dragscroll'

  import HMTImageWrapper from '@/shared/components/ImageWrapper';

  export default {
    name: 'HMTLightbox',
    components: {
      HMTImageWrapper
    },
    directives: {
      dragscroll
    },
    data () {
      return {
        photo: '',
        distance: 0,
        opacity: 1,
        hideDuration: 350,
        showDuration: 150,
        threshold: 30,
        thresholdPhone: 5,
        bound: 50,
        isTransitionClass: true,
        isGrabbingClass: false,
        photoSize: 'xl'
      }
    },
    props: {
      show: {
        default: false,
        type: Boolean
      },
      index: {
        default: 0,
        type: Number
      },
      items: {
        type: Array
      }
    },
    methods: {
      onDragMove (event) {
        this.updateDistance(this.distance - parseInt(event.detail.deltaX / 2));

        this.isGrabbingClass = true;
      },
      onDragEnd () {
        if (this.distance > this.threshold) {
          this.prevPhoto();
        } else if (this.distance < -this.threshold) {
          this.nextPhoto();
        } else {
          this.updateDistance(0);
        }

        this.isGrabbingClass = false;
      },
      onArrowsKeyUp (evt) {
        if (this.opacity !== 1) {
          return;
        }

        switch (evt.code) {
          case 'ArrowLeft':
            this.onPrevious();
            break;
          case 'ArrowRight':
            this.onNext();
            break;
          case 'Escape':
            this.close();
            break;
        }
      },
      onPrevious () {
        this.updateDistance(this.bound);
        this.prevPhoto();
      },
      onNext () {
        this.updateDistance(-this.bound);
        this.nextPhoto();
      },
      prevPhoto () {
        if (this.photoIndex === 0) {
          this.photoIndex = this.items.length - 1;
        } else {
          this.photoIndex = --this.photoIndex;
        }

        this.hidePhoto(-this.bound);
      },
      nextPhoto () {
        if (this.photoIndex === this.items.length - 1) {
          this.photoIndex = 0;
        } else {
          this.photoIndex = ++this.photoIndex;
        }

        this.hidePhoto(this.bound);
      },
      hidePhoto (distance) {
        this.updateOpacity(0);

        setTimeout(() => {
          this.isTransitionClass = false;

          this.updatePhoto();
          this.updateDistance(distance);
          this.showPhoto();
        }, this.hideDuration);
      },
      showPhoto () {
        setTimeout(() => {
          this.isTransitionClass = true;

          this.updateDistance(0);
          this.updateOpacity(1);
        }, this.showDuration);
      },
      updateDistance (distance) {
        this.distance = distance;
      },
      updateOpacity (opacity) {
        this.opacity = opacity;
      },
      updatePhoto () {
        this.photo = this.items[this.photoIndex][this.photoSize];
      },
      setThreshold () {
        const phoneViewport = window.matchMedia('screen and (max-width: 799px)');

        if(phoneViewport.matches) {
          this.threshold = this.thresholdPhone;
        }
      },
      init () {
        this.photoIndex = this.index;

        this.updatePhoto();
        this.setThreshold();

        document.addEventListener('keyup', this.onArrowsKeyUp);
      },
      destroy () {
        document.removeEventListener('keyup', this.onArrowsKeyUp);
      },
      close () {
        this.$emit('onClose');
      },
    },
    watch: {
      show () {
        if (this.show) {
          this.init();
        } else {
          this.destroy();
        }
      }
    }
  };
</script>

<style src="./styles.scss" lang="scss"></style>
